import type { Dispatch } from '@reduxjs/toolkit'
import { v4 as uuid } from 'uuid'
import type { ApiError, Business, User } from '@pbt/pbt-ui-components'
import { SentryUtils } from '@pbt/pbt-ui-components'

import { addError } from '~/store/duck/errors'
import { isNetworkError } from '~/utils/errors'
import { getLockRocketSessionURL } from '~/utils/LogRocket'

import { TransactionFailureReasonName } from './paymentErrorMapping'

export const triggerErrorDoggo = (
  dispatch: Dispatch<any>,
  errorMessage: string,
  statusCode: number = 500,
  currentUser?: User | null,
  currentBusiness?: Business | null,
): void => {
  const errorInstance = new Error(errorMessage)
  const generatedErrorId = uuid()

  dispatch(
    addError(errorInstance, statusCode, generatedErrorId, window.location.href),
  )
  // `isNetworkError` checks `originalMessage`, but `Error` instances only have `message`.
  // Pass the expected shape so network errors are correctly excluded from Sentry.
  if (!isNetworkError({ originalMessage: errorInstance.message })) {
    if (currentUser !== undefined || currentBusiness !== undefined) {
      SentryUtils.captureSentryException(
        errorInstance as ApiError,
        undefined,
        currentUser ?? undefined,
        currentBusiness ?? undefined,
        generatedErrorId,
        getLockRocketSessionURL(),
      )
    }
  }
}

/**
 * Triggers error doggo for transaction failure, unless the failure is DEVICE_TIMEOUT.
 * DEVICE_TIMEOUT is a transient connectivity issue that doesn't warrant error reporting.
 */
export const triggerErrorDoggoForTransactionFailureIfNeeded = ({
  failureReasonName,
  dispatch,
  backendErrorMessage,
  fallbackMessage,
  currentUser,
  currentBusiness,
}: {
  backendErrorMessage: string | null
  currentBusiness?: Business | null
  currentUser?: User | null
  dispatch: Dispatch<any>
  failureReasonName: string | null | undefined
  fallbackMessage: string
}): void => {
  if (failureReasonName === TransactionFailureReasonName.DEVICE_TIMEOUT) {
    return
  }
  const message = backendErrorMessage || fallbackMessage
  triggerErrorDoggo(dispatch, message, 500, currentUser, currentBusiness)
}
